<mat-dropdown
  [formControl]="formControl()"
  [options]="widgetRequestCategoryDropdownOptions()"
  [configurationInput]="widgetRequestCategoryDropdownConfiguration()"
  [isFormSubmitted]="isFormSubmitted()"
></mat-dropdown>
